// Should contain only letters a-zA-Z, parenthesis (), numbers \d, hyphens \-, or spaces \s.

export const NAME_VALIDATION_PATTERN = /^[a-zA-Z()\-\d\s]+$/;
